(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsPercentChange', function wsPercentChange() {
    return {
      scope: {
        change: '='
      },
      replace: true,
      templateUrl: "modules/common/directives/percent-change/percent-change.html"
    };
  });
})();
